/*
 * Lets non-React code (e.g. showApiError's toast button) change route through
 * the app router. NavigationProvider registers its unsaved-changes-aware
 * navigate here; before that, fall back to a full page load.
 */
type AppNavigate = (to: string) => void;

let current: AppNavigate | null = null;

export function setAppNavigate(fn: AppNavigate | null): void {
  current = fn;
}

export function appNavigate(to: string): void {
  if (current) current(to);
  else window.location.assign(to);
}
